export default "__VITE_ASSET__be48fc94__"